var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _mask2, _g, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _mask3, _g2, _path139, _path140, _path141, _path142, _path143, _mask4, _g3, _path144, _path145, _path146, _path147, _mask5, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAich4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 153,
    viewBox: "0 0 197 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3195 30.0703C88.3195 30.0703 79.0584 18.5402 94.5077 3C110.256 9.57321 104.406 29.3701 104.406 29.3701",
    stroke: "#FEB9D6",
    strokeWidth: 3.59654,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0237 30.7854C67.0237 30.7854 101.085 38.5529 125.88 27.4988C131.856 28.0964 152.497 65.143 142.923 78.886C133.35 92.629 54.1734 96.8116 50.2934 77.3924C46.4133 57.9731 62.3809 29.9138 67.0237 30.7854Z",
    fill: "#FEB9D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.923 78.886C143.819 77.5987 144.451 76.1072 144.854 74.4612C94.948 96.3578 59.2873 69.7096 50.5572 62.105C49.5819 67.3506 49.3396 72.6312 50.2927 77.3924C54.1759 96.8116 133.349 92.629 142.923 78.886Z",
    fill: "#FEB9D6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5083 56.6572C94.2523 56.7757 87.1756 60.9392 85.7285 70.14",
    stroke: "#FB61A2",
    strokeWidth: 0.528903,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3262 56.6572C96.3262 56.6572 101.199 58.5359 103.942 68.547",
    stroke: "#FB61A2",
    strokeWidth: 0.528903,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5882 82.2741C67.2282 84.7748 111.658 89.2726 146.831 77.6727C149.22 76.8846 151.823 77.7943 153.258 79.929C162.153 93.1611 183.238 120.528 167.081 139.077C166.578 139.655 165.963 140.126 165.274 140.461C153.963 145.961 99.8266 163.415 29.9109 140.559C28.5302 140.102 27.3747 139.138 26.6782 137.861C18.7605 123.508 30.2494 100.177 37.2066 88.3745C39.8035 83.9698 44.6599 81.5749 49.5882 82.2741Z",
    fill: "#FB61A2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0212 33.0427C67.0212 33.0427 62.241 62.3799 94.5073 61.3052C126.774 60.2305 124.683 42.6032 125.878 29.7529C121.317 31.5512 67.0212 33.0427 67.0212 33.0427Z",
    fill: "#FEB9D6"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 77,
    width: 149,
    height: 76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5882 82.2741C67.2282 84.7748 111.658 89.2726 146.831 77.6727C149.22 76.8846 151.823 77.7943 153.258 79.929C162.153 93.1611 183.238 120.528 167.081 139.077C166.578 139.655 165.963 140.126 165.274 140.461C153.963 145.961 99.8266 163.415 29.9109 140.559C28.5302 140.102 27.3747 139.138 26.6782 137.861C18.7605 123.508 30.2494 100.177 37.2066 88.3745C39.8035 83.9698 44.6599 81.5749 49.5882 82.2741Z",
    fill: "#097771"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.2827 114.805C75.6653 114.805 76.7862 113.663 76.7862 112.254C76.7862 110.845 75.6653 109.703 74.2827 109.703C72.9001 109.703 71.7793 110.845 71.7793 112.254C71.7793 113.663 72.9001 114.805 74.2827 114.805Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.4199 109.313C75.4199 109.313 76.7219 106.64 78.228 105.5",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M77.1934 110.236L80.3377 108.416",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M77.834 112.567L82.0645 112.216",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.8398 114.567C77.4822 115.214 78.1245 115.861 78.7669 116.507",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.8145 115.455L75.8393 119.626",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.7279 115.379C72.3655 116.487 72.003 117.595 71.6406 118.702",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.6129 112.262L66.7324 112.171",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.3701 110.04L68.0703 107.151",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.0808 109.206L72.498 105.726",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.7087 114.231L68.4961 115.458",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M107.64 129.94C109.023 129.94 110.144 128.798 110.144 127.389C110.144 125.98 109.023 124.838 107.64 124.838C106.258 124.838 105.137 125.98 105.137 127.389C105.137 128.798 106.258 129.94 107.64 129.94Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.779 124.448C108.779 124.448 110.081 121.775 111.587 120.641",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.553 125.371L113.697 123.552",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.195 127.706L115.426 127.354",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.199 129.703L112.125 131.643",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.172 130.592C108.513 131.981 108.854 133.371 109.196 134.762",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.088 130.515C105.726 131.622 105.364 132.73 105.002 133.837",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.973 127.395L100.094 127.305",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.731 125.173L101.432 122.286",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.438 124.342L105.855 120.862",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.069 129.368L101.857 130.595",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.31 117.095C163.693 117.095 164.814 115.953 164.814 114.544C164.814 113.135 163.693 111.993 162.31 111.993C160.927 111.993 159.807 113.135 159.807 114.544C159.807 115.953 160.927 117.095 162.31 117.095Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.449 111.603C163.449 111.603 164.751 108.931 166.257 107.796",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.221 112.526L168.365 110.706",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.861 114.858L170.092 114.508",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.867 116.858L166.793 118.797",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.844 117.745C163.186 119.137 163.527 120.527 163.868 121.917",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.756 117.669L159.67 120.993",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.639 114.55L154.76 114.459",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.401 112.328L156.102 109.439",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.108 111.497L160.525 108.016",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.736 116.521L156.523 117.748",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.812 88.217C92.1946 88.217 93.3155 87.0749 93.3155 85.666C93.3155 84.2571 92.1946 83.115 90.812 83.115C89.4294 83.115 88.3086 84.2571 88.3086 85.666C88.3086 87.0749 89.4294 88.217 90.812 88.217Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M91.9512 82.7252C91.9512 82.7252 93.2542 80.0526 94.7603 78.9177",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.7246 83.6478L96.869 81.8286",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.3652 85.9795L98.5958 85.6294",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.3691 87.98L95.2983 89.9186",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M91.3438 88.8684C91.6857 90.2581 92.027 91.6482 92.3675 93.0387",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.2581 88.7913C88.8964 89.8997 88.5343 91.0074 88.1719 92.1144",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.1431 85.6718L83.2637 85.5808",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.9014 83.4496L84.6016 80.5623",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.6101 82.6194L89.0273 79.1377",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.2399 87.6445L85.0273 88.8703",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.452 82.8432C165.083 82.8432 167.216 80.7101 167.216 78.0788C167.216 75.4475 165.083 73.3145 162.452 73.3145C159.821 73.3145 157.688 75.4475 157.688 78.0788C157.688 80.7101 159.821 82.8432 162.452 82.8432Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.211 78.6637L177.26 78.01",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.318 82.3977L170.984 86.0191",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.465 84.0566C164.115 86.6525 164.765 89.2484 165.414 91.8442",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.497 83.9126C158.808 85.9813 158.119 88.0494 157.43 90.1167",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.471 78.0945L148.088 77.9253",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.656 81.7715L151.445 84.0613",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M139.053 157.726C141.685 157.726 143.818 155.593 143.818 152.962C143.818 150.331 141.685 148.198 139.053 148.198C136.422 148.198 134.289 150.331 134.289 152.962C134.289 155.593 136.422 157.726 139.053 157.726Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.219 147.472C141.219 147.472 143.696 142.481 146.563 140.353",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.592 149.194L150.575 145.796",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M133.511 148.824L127.232 143.43",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.768 147.275L135.66 140.775",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.147 102.162C119.778 102.162 121.912 100.029 121.912 97.3977C121.912 94.7664 119.778 92.6333 117.147 92.6333C114.516 92.6333 112.383 94.7664 112.383 97.3977C112.383 100.029 114.516 102.162 117.147 102.162Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.311 91.9076C119.311 91.9076 121.788 86.9169 124.655 84.7886",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.688 93.6291L128.671 90.2319",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.906 97.9814L131.955 97.3267",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.012 101.716L125.676 105.337",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M118.156 103.376C118.807 105.972 119.457 108.568 120.106 111.164",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.191 103.232C113.501 105.302 112.811 107.37 112.119 109.436",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.164 97.407L102.779 97.241",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.604 93.2594L105.326 87.8655",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.856 91.7085L113.748 85.2083",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.349 101.09L106.139 103.376",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.0186 147.409C70.8238 147.409 72.2872 145.945 72.2872 144.14C72.2872 142.335 70.8238 140.871 69.0186 140.871C67.2134 140.871 65.75 142.335 65.75 144.14C65.75 145.945 67.2134 147.409 69.0186 147.409Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.5039 140.373C70.5039 140.373 72.2035 136.95 74.1697 135.49",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.8203 141.555L76.924 139.229",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.6582 144.542L79.1791 144.092",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.3574 147.103L74.8725 149.586",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.7148 148.241L71.0517 153.582",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.9915 148.143L65.5742 152.399",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.228 144.147L59.1641 144.031",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.2188 141.301L60.9121 137.599",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.4479 140.237L66.6875 135.779",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.3572 146.673L61.4688 148.244",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.2965 117.717C47.4072 117.717 49.1183 115.987 49.1183 113.853C49.1183 111.719 47.4072 109.989 45.2965 109.989C43.1857 109.989 41.4746 111.719 41.4746 113.853C41.4746 115.987 43.1857 117.717 45.2965 117.717Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.0332 109.398C47.0332 109.398 49.0205 105.351 51.3198 103.626",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.7383 110.796L54.5368 108.04",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7168 114.328L57.1694 113.799",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.1992 117.356L52.1395 120.292",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.1094 118.702C46.6297 120.806 47.1508 122.911 47.6726 125.017",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.922 118.585C42.3686 120.263 41.8158 121.94 41.2637 123.618",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.6923 113.861L33.7695 113.724",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.8518 110.497L35.8164 106.126",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.4568 109.238L42.5684 103.967",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.8438 116.848L36.4668 118.705",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.4317 125.543C81.2469 125.544 81.063 125.569 80.8848 125.618C80.8848 125.584 80.8848 125.548 80.8848 125.512C80.8717 124.984 80.6538 124.482 80.2773 124.112C79.9007 123.742 79.395 123.534 78.8671 123.53C78.3393 123.527 77.8308 123.728 77.4493 124.093C77.0677 124.458 76.843 124.957 76.8228 125.484C76.2948 125.484 75.7885 125.694 75.4151 126.067C75.0418 126.441 74.832 126.947 74.832 127.475C74.832 128.003 75.0418 128.509 75.4151 128.883C75.7885 129.256 76.2948 129.466 76.8228 129.466V129.494C76.8228 130.033 77.0368 130.55 77.4177 130.931C77.7986 131.311 78.3152 131.525 78.8538 131.525C79.3925 131.525 79.9091 131.311 80.2899 130.931C80.6708 130.55 80.8848 130.033 80.8848 129.494C80.8848 129.48 80.8848 129.465 80.8848 129.45C81.0624 129.498 81.2456 129.523 81.4296 129.523C81.9578 129.523 82.4645 129.313 82.838 128.94C83.2116 128.566 83.4214 128.059 83.4214 127.531C83.4214 127.003 83.2116 126.496 82.838 126.123C82.4645 125.749 81.9578 125.539 81.4296 125.539L81.4317 125.543ZM78.8845 127.507C79.0597 127.505 79.2339 127.48 79.4028 127.434C79.4028 127.468 79.4028 127.501 79.4028 127.54C79.4028 127.554 79.4028 127.569 79.4028 127.584C79.2341 127.538 79.0603 127.514 78.8855 127.512L78.8845 127.507Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.8666 86.2102C53.5037 86.2096 53.1422 86.2551 52.7908 86.3456C52.7908 86.2821 52.7961 86.2187 52.7961 86.1541C52.7961 84.0787 51.0031 82.3958 48.7923 82.3958C46.5994 82.3958 44.8202 84.0502 44.7906 86.0981C42.6052 86.1266 40.8418 87.798 40.8418 89.8565C40.8418 91.915 42.6052 93.5863 44.7906 93.6138C44.7906 93.6318 44.7906 93.6498 44.7906 93.6688C44.7906 95.7442 46.5825 97.4272 48.7933 97.4272C51.0041 97.4272 52.7971 95.7442 52.7971 93.6688C52.7971 93.6402 52.7971 93.6117 52.7971 93.5831C53.1476 93.6752 53.5085 93.7217 53.8708 93.7217C56.0816 93.7217 57.8746 92.0387 57.8746 89.9622C57.8746 87.8858 56.0774 86.2102 53.8666 86.2102ZM48.8473 89.9125C49.1922 89.9076 49.5352 89.8615 49.8691 89.775C49.8691 89.8385 49.8638 89.902 49.8638 89.9665C49.8638 89.995 49.8638 90.0225 49.8638 90.0511C49.5311 89.9645 49.189 89.9187 48.8452 89.9146L48.8473 89.9125Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.981 134.306C167.618 134.307 167.256 134.353 166.904 134.445C166.904 134.381 166.904 134.318 166.904 134.254C166.904 132.178 165.112 130.495 162.902 130.495C160.709 130.495 158.929 132.15 158.899 134.197C156.713 134.226 154.951 135.897 154.951 137.956C154.951 140.014 156.713 141.686 158.9 141.713C158.9 141.731 158.9 141.749 158.9 141.768C158.9 143.844 160.698 145.527 162.904 145.527C165.109 145.527 166.911 143.848 166.911 141.775C166.911 141.746 166.911 141.717 166.911 141.689C167.261 141.781 167.622 141.828 167.984 141.827C170.195 141.827 171.987 140.144 171.987 138.068C171.987 135.991 170.19 134.306 167.981 134.306ZM162.962 138.009C163.306 138.004 163.649 137.958 163.983 137.871C163.983 137.935 163.983 137.998 163.983 138.063C163.983 138.091 163.983 138.119 163.983 138.147C163.65 138.061 163.308 138.015 162.964 138.011L162.962 138.009Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.315 143.369C112.952 143.369 112.59 143.415 112.238 143.507C112.238 143.444 112.238 143.379 112.238 143.316C112.238 141.239 110.446 139.556 108.236 139.556C106.043 139.556 104.263 141.212 104.233 143.259C102.047 143.286 100.285 144.958 100.285 147.016C100.285 149.075 102.047 150.746 104.234 150.774C104.234 150.792 104.234 150.81 104.234 150.828C104.234 152.905 106.032 154.588 108.238 154.588C110.443 154.588 112.24 152.905 112.24 150.828C112.24 150.8 112.24 150.771 112.24 150.744C112.591 150.835 112.952 150.881 113.314 150.881C115.525 150.881 117.317 149.198 117.317 147.122C117.317 145.045 115.526 143.369 113.315 143.369ZM108.296 147.071C108.641 147.067 108.983 147.021 109.317 146.934C109.317 146.997 109.317 147.062 109.317 147.125C109.317 147.154 109.317 147.182 109.317 147.211C108.984 147.124 108.642 147.078 108.298 147.074L108.296 147.071Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.052 94.2791C151.688 94.2794 151.326 94.326 150.975 94.4176C150.975 94.3542 150.975 94.2907 150.975 94.2262C150.975 92.1507 149.183 90.4678 146.972 90.4678C144.779 90.4678 143 92.1222 142.97 94.1701C140.785 94.1987 139.021 95.87 139.021 97.9285C139.021 99.987 140.786 101.659 142.976 101.684C142.976 101.702 142.976 101.72 142.976 101.739C142.976 103.814 144.774 105.497 146.979 105.497C149.185 105.497 150.982 103.814 150.982 101.739C150.982 101.71 150.982 101.682 150.982 101.653C151.333 101.745 151.693 101.792 152.056 101.792C154.267 101.792 156.059 100.109 156.059 98.0322C156.059 95.9557 154.262 94.2791 152.052 94.2791ZM147.032 97.9814C147.377 97.9765 147.719 97.9303 148.053 97.8439C148.053 97.9073 148.053 97.9708 148.053 98.0353C148.053 98.0639 148.053 98.0914 148.053 98.12C147.72 98.0333 147.378 97.9875 147.034 97.9835L147.032 97.9814Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.0248 95.9323C72.8366 95.9321 72.6491 95.9566 72.4673 96.0053C72.4673 95.9714 72.4673 95.9362 72.4673 95.8995C72.4673 94.793 71.5396 93.8896 70.3951 93.8896C69.2505 93.8896 68.3429 94.7824 68.3249 95.8762C67.1941 95.891 66.2812 96.7817 66.2812 97.8797C66.2812 98.9777 67.1963 99.8684 68.3249 99.8853C68.3249 99.8959 68.3249 99.9054 68.3249 99.9149C68.3249 101.021 69.2526 101.918 70.3972 101.918C71.5417 101.918 72.4694 101.021 72.4694 99.9149C72.4694 99.8991 72.4694 99.8842 72.4694 99.8694C72.6505 99.9184 72.8372 99.9433 73.0248 99.9435C74.1693 99.9435 75.096 99.0454 75.096 97.9389C75.096 96.8325 74.1693 95.9323 73.0248 95.9323ZM70.4268 97.9072C70.6055 97.9043 70.7831 97.8794 70.9557 97.8331C70.9557 97.867 70.9557 97.9019 70.9557 97.9389C70.9557 97.9537 70.9557 97.9696 70.9557 97.9844C70.7832 97.9379 70.6055 97.9133 70.4268 97.9114V97.9072Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M133.769 111.466C133.581 111.467 133.393 111.491 133.211 111.54C133.211 111.507 133.211 111.473 133.211 111.435C133.211 110.328 132.284 109.431 131.139 109.431C129.995 109.431 129.084 110.313 129.068 111.407C127.937 111.422 127.025 112.313 127.025 113.411C127.025 114.509 127.937 115.399 129.068 115.414V115.443C129.068 116.549 129.996 117.452 131.139 117.452C132.283 117.452 133.211 116.554 133.211 115.443C133.211 115.428 133.211 115.413 133.211 115.397C133.393 115.446 133.579 115.471 133.767 115.471C134.911 115.471 135.839 114.574 135.839 113.467C135.839 112.359 134.913 111.466 133.769 111.466ZM131.171 113.441C131.35 113.439 131.527 113.415 131.7 113.368C131.7 113.402 131.7 113.437 131.7 113.474C131.7 113.49 131.7 113.505 131.7 113.52C131.527 113.473 131.35 113.449 131.171 113.447V113.441Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.911 121.423C146.723 121.424 146.536 121.449 146.354 121.498C146.354 121.464 146.354 121.428 146.354 121.392C146.354 120.285 145.426 119.387 144.282 119.387C143.137 119.387 142.226 120.27 142.211 121.364C141.08 121.379 140.168 122.27 140.168 123.368C140.168 124.466 141.08 125.355 142.211 125.37V125.4C142.211 126.506 143.138 127.403 144.282 127.403C145.425 127.403 146.354 126.506 146.354 125.4C146.354 125.384 146.354 125.369 146.354 125.354C146.535 125.403 146.722 125.427 146.909 125.427C148.054 125.427 148.982 124.53 148.982 123.424C148.982 122.317 148.056 121.423 146.911 121.423ZM144.314 123.399C144.492 123.397 144.67 123.372 144.842 123.325C144.842 123.359 144.842 123.394 144.842 123.431C144.842 123.446 144.842 123.461 144.842 123.477C144.67 123.43 144.492 123.406 144.314 123.404V123.399Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.4399 72.6312C69.2517 72.6311 69.0642 72.6556 68.8824 72.7042C68.8824 72.6704 68.8824 72.6351 68.8824 72.5985C68.8824 71.492 67.9547 70.5886 66.8102 70.5886C65.6656 70.5886 64.7549 71.4719 64.739 72.5657C63.6082 72.5805 62.6953 73.4711 62.6953 74.5692C62.6953 75.6672 63.6082 76.5578 64.739 76.5726C64.739 76.5822 64.739 76.5917 64.739 76.6012C64.739 77.7077 65.6667 78.6047 66.8112 78.6047C67.9558 78.6047 68.8856 77.7172 68.8856 76.6139C68.8856 76.5991 68.8856 76.5832 68.8856 76.5684C69.0667 76.6174 69.2534 76.6423 69.4409 76.6425C70.5855 76.6425 71.5132 75.7444 71.5132 74.6326C71.5132 73.5209 70.5844 72.6312 69.4399 72.6312ZM66.844 74.6041C67.0226 74.601 67.2002 74.5765 67.3729 74.5311C67.3729 74.5649 67.3729 74.6002 67.3729 74.6369C67.3729 74.6517 67.3729 74.6675 67.3729 74.6823C67.2004 74.6358 67.0227 74.6112 66.844 74.6093V74.6041Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.8148 139.584C48.6255 139.584 48.437 139.609 48.2542 139.658C48.2542 139.624 48.2542 139.59 48.2542 139.552C48.2542 138.452 47.3222 137.56 46.1713 137.56C45.0204 137.56 44.1033 138.437 44.0885 139.525C42.9503 139.539 42.0332 140.425 42.0332 141.515C42.0332 142.606 42.9503 143.491 44.0885 143.506C44.0885 143.516 44.0885 143.525 44.0885 143.535C44.0885 144.635 45.0215 145.527 46.1724 145.527C47.3233 145.527 48.2552 144.635 48.2552 143.535C48.2552 143.52 48.2552 143.505 48.2552 143.49C48.4378 143.539 48.6259 143.563 48.8148 143.563C49.9646 143.563 50.8976 142.672 50.8976 141.571C50.8976 140.471 49.9646 139.584 48.8148 139.584ZM46.202 141.547C46.3807 141.545 46.5584 141.521 46.7309 141.474C46.7309 141.508 46.7309 141.542 46.7309 141.58C46.7309 141.595 46.7309 141.611 46.7309 141.625C46.5583 141.58 46.3806 141.555 46.202 141.552V141.547Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.3018 137.515C94.0563 137.515 93.8119 137.548 93.5751 137.613C93.5751 137.568 93.5751 137.523 93.5751 137.478C93.5668 136.769 93.2809 136.093 92.7787 135.593C92.2766 135.093 91.5984 134.811 90.8901 134.806C90.1817 134.801 89.4997 135.074 88.9908 135.567C88.4819 136.06 88.1867 136.733 88.1687 137.441C87.8162 137.434 87.4658 137.497 87.1381 137.627C86.8104 137.757 86.5119 137.951 86.2601 138.198C86.0083 138.445 85.8083 138.739 85.6717 139.064C85.5352 139.389 85.4648 139.738 85.4648 140.091C85.4648 140.444 85.5352 140.793 85.6717 141.118C85.8083 141.443 86.0083 141.737 86.2601 141.984C86.5119 142.231 86.8104 142.425 87.1381 142.555C87.4658 142.685 87.8162 142.748 88.1687 142.741C88.1687 142.755 88.1687 142.768 88.1687 142.781C88.1687 143.498 88.4535 144.185 88.9606 144.692C89.4676 145.199 90.1553 145.484 90.8724 145.484C91.5895 145.484 92.2772 145.199 92.7843 144.692C93.2913 144.185 93.5762 143.498 93.5762 142.781C93.5762 142.76 93.5762 142.74 93.5762 142.72C93.8123 142.785 94.056 142.817 94.3008 142.818C94.6534 142.825 95.0039 142.761 95.3318 142.631C95.6596 142.501 95.9582 142.307 96.2101 142.06C96.462 141.813 96.6621 141.518 96.7987 141.193C96.9353 140.868 97.0057 140.519 97.0057 140.166C97.0057 139.813 96.9353 139.464 96.7987 139.139C96.6621 138.814 96.462 138.519 96.2101 138.272C95.9582 138.025 95.6596 137.831 95.3318 137.701C95.0039 137.571 94.6534 137.508 94.3008 137.515H94.3018ZM90.9168 140.128C91.1499 140.125 91.3817 140.093 91.6065 140.031C91.6065 140.076 91.6065 140.121 91.6065 140.167C91.6065 140.187 91.6065 140.206 91.6065 140.226C91.3819 140.165 91.1506 140.133 90.9179 140.13L90.9168 140.128Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.7903 110.928C96.5444 110.928 96.2996 110.96 96.0625 111.025C96.0625 110.981 96.0625 110.935 96.0625 110.89C96.048 110.185 95.7592 109.514 95.2575 109.019C94.7558 108.525 94.0809 108.245 93.3762 108.241C92.6716 108.236 91.993 108.506 91.4848 108.994C90.9765 109.482 90.6788 110.15 90.655 110.854C90.3025 110.847 89.9521 110.91 89.6244 111.04C89.2967 111.17 88.9982 111.364 88.7464 111.611C88.4946 111.858 88.2946 112.152 88.1581 112.478C88.0215 112.803 87.9512 113.152 87.9512 113.504C87.9512 113.857 88.0215 114.206 88.1581 114.531C88.2946 114.856 88.4946 115.15 88.7464 115.397C88.9982 115.644 89.2967 115.838 89.6244 115.968C89.9521 116.098 90.3025 116.162 90.655 116.155C90.655 116.167 90.655 116.18 90.655 116.193C90.669 116.901 90.9601 117.575 91.4657 118.071C91.9713 118.566 92.6512 118.844 93.3593 118.844C94.0674 118.844 94.7472 118.566 95.2529 118.071C95.7585 117.575 96.0495 116.901 96.0636 116.193C96.0636 116.172 96.0636 116.152 96.0636 116.133C96.3001 116.197 96.5441 116.23 96.7892 116.23C97.1373 116.23 97.482 116.161 97.8037 116.028C98.1253 115.895 98.4175 115.699 98.6637 115.453C98.9098 115.207 99.1051 114.915 99.2383 114.593C99.3715 114.272 99.4401 113.927 99.4401 113.579C99.4401 113.231 99.3715 112.886 99.2383 112.564C99.1051 112.243 98.9098 111.95 98.6637 111.704C98.4175 111.458 98.1253 111.263 97.8037 111.13C97.482 110.996 97.1373 110.928 96.7892 110.928H96.7903ZM93.3958 113.541C93.6289 113.538 93.8606 113.505 94.0855 113.443C94.0855 113.489 94.0855 113.533 94.0855 113.579C94.0855 113.599 94.0855 113.619 94.0855 113.639C93.8613 113.578 93.6302 113.545 93.3979 113.543L93.3958 113.541Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M128.755 129.549C128.509 129.549 128.264 129.582 128.027 129.647C128.027 129.602 128.027 129.557 128.027 129.512C128.013 128.807 127.724 128.136 127.222 127.641C126.721 127.147 126.046 126.867 125.341 126.862C124.636 126.858 123.958 127.128 123.45 127.616C122.941 128.104 122.644 128.771 122.62 129.476C122.267 129.469 121.917 129.532 121.589 129.662C121.262 129.792 120.963 129.986 120.711 130.233C120.459 130.48 120.259 130.774 120.123 131.099C119.986 131.424 119.916 131.773 119.916 132.126C119.916 132.479 119.986 132.828 120.123 133.153C120.259 133.478 120.459 133.772 120.711 134.019C120.963 134.266 121.262 134.46 121.589 134.59C121.917 134.72 122.267 134.783 122.62 134.776C122.62 134.789 122.62 134.802 122.62 134.814C122.634 135.522 122.925 136.197 123.431 136.692C123.936 137.188 124.616 137.466 125.324 137.466C126.032 137.466 126.712 137.188 127.218 136.692C127.723 136.197 128.014 135.522 128.028 134.814C128.028 134.794 128.028 134.774 128.028 134.754C128.265 134.819 128.509 134.852 128.754 134.851C129.107 134.858 129.457 134.795 129.785 134.665C130.113 134.535 130.412 134.341 130.663 134.094C130.915 133.847 131.115 133.552 131.252 133.227C131.389 132.902 131.459 132.553 131.459 132.2C131.459 131.847 131.389 131.498 131.252 131.173C131.115 130.848 130.915 130.553 130.663 130.306C130.412 130.059 130.113 129.865 129.785 129.735C129.457 129.605 129.107 129.542 128.754 129.549H128.755ZM125.364 132.161C125.597 132.159 125.829 132.126 126.055 132.065C126.055 132.11 126.055 132.155 126.055 132.201C126.055 132.221 126.055 132.24 126.055 132.26C125.83 132.199 125.599 132.167 125.366 132.164L125.364 132.161Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.8467 124.968C59.6013 124.968 59.3569 125.001 59.12 125.065C59.12 125.021 59.12 124.976 59.12 124.931C59.1117 124.223 58.8258 123.546 58.3237 123.046C57.8215 122.547 57.1434 122.264 56.435 122.259C55.7266 122.254 55.0446 122.528 54.5357 123.02C54.0268 123.513 53.7316 124.186 53.7136 124.894C53.3611 124.887 53.0107 124.95 52.683 125.08C52.3553 125.21 52.0568 125.405 51.805 125.651C51.5532 125.898 51.3532 126.193 51.2166 126.518C51.0801 126.843 51.0098 127.192 51.0098 127.544C51.0098 127.897 51.0801 128.246 51.2166 128.571C51.3532 128.896 51.5532 129.191 51.805 129.438C52.0568 129.684 52.3553 129.878 52.683 130.008C53.0107 130.138 53.3611 130.202 53.7136 130.195C53.7136 130.207 53.7136 130.22 53.7136 130.233C53.7136 130.95 53.9984 131.638 54.5055 132.145C55.0125 132.652 55.7003 132.937 56.4173 132.937C57.1344 132.937 57.8221 132.652 58.3292 132.145C58.8362 131.638 59.1211 130.95 59.1211 130.233C59.1211 130.213 59.1211 130.194 59.1211 130.174C59.3573 130.238 59.6009 130.271 59.8457 130.271C60.1983 130.278 60.5488 130.215 60.8767 130.085C61.2045 129.954 61.5031 129.76 61.755 129.513C62.0069 129.266 62.207 128.972 62.3436 128.647C62.4802 128.321 62.5506 127.972 62.5506 127.62C62.5506 127.267 62.4802 126.918 62.3436 126.592C62.207 126.267 62.0069 125.973 61.755 125.726C61.5031 125.479 61.2045 125.285 60.8767 125.155C60.5488 125.024 60.1983 124.961 59.8457 124.968H59.8467ZM56.4618 127.581C56.6948 127.578 56.9265 127.545 57.1515 127.485C57.1515 127.529 57.1515 127.575 57.1515 127.619C57.1515 127.639 57.1515 127.659 57.1515 127.679C56.9273 127.618 56.6962 127.586 56.4639 127.583L56.4618 127.581Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.8439 125.068C36.598 125.068 36.3532 125.101 36.1161 125.166C36.1161 125.121 36.1161 125.076 36.1161 125.031C36.1078 124.322 35.8219 123.646 35.3197 123.146C34.8176 122.646 34.1394 122.364 33.4311 122.359C32.7227 122.354 32.0407 122.627 31.5318 123.12C31.0229 123.613 30.7277 124.286 30.7097 124.994C30.3572 124.987 30.0068 125.05 29.6791 125.18C29.3514 125.31 29.0529 125.504 28.8011 125.751C28.5493 125.998 28.3493 126.292 28.2127 126.617C28.0762 126.942 28.0059 127.291 28.0059 127.644C28.0059 127.997 28.0762 128.346 28.2127 128.671C28.3493 128.996 28.5493 129.29 28.8011 129.537C29.0529 129.784 29.3514 129.978 29.6791 130.108C30.0068 130.238 30.3572 130.301 30.7097 130.294C30.7097 130.307 30.7097 130.32 30.7097 130.334C30.7097 131.051 30.9945 131.738 31.5016 132.245C32.0086 132.752 32.6963 133.037 33.4134 133.037C34.1305 133.037 34.8182 132.752 35.3253 132.245C35.8323 131.738 36.1172 131.051 36.1172 130.334C36.1172 130.313 36.1172 130.293 36.1172 130.273C36.3537 130.338 36.5977 130.37 36.8428 130.371C37.1955 130.378 37.546 130.314 37.8738 130.184C38.2017 130.054 38.5003 129.86 38.7522 129.613C39.0041 129.366 39.2042 129.071 39.3408 128.746C39.4774 128.421 39.5477 128.072 39.5477 127.719C39.5477 127.366 39.4774 127.017 39.3408 126.692C39.2042 126.367 39.0041 126.072 38.7522 125.825C38.5003 125.578 38.2017 125.384 37.8738 125.254C37.546 125.124 37.1955 125.061 36.8428 125.068H36.8439ZM33.4526 127.681C33.686 127.678 33.9181 127.646 34.1433 127.584C34.1433 127.629 34.1433 127.674 34.1433 127.719C34.1433 127.739 34.1433 127.759 34.1433 127.779C33.9187 127.718 33.6873 127.686 33.4547 127.683L33.4526 127.681Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M136.337 132.664C147.689 124.299 142.754 85.347 135.982 83.7286C134.441 83.3605 129.755 83.1595 123.436 83.0696C100.764 86.4334 77.5167 85.3185 61.6697 83.7286C61.6697 83.7286 48.7983 120.713 56.5668 129.677C64.3353 138.64 124.98 141.034 136.337 132.664Z",
    fill: "#FEB9D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7188 106.694L56.8827 106.08",
    stroke: "#FEB9D6",
    strokeWidth: 0.423123,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2129 104.84L61.7096 88.0996",
    stroke: "#FEB9D6",
    strokeWidth: 0.423123,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "1.28 1.28"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8789 87.4794L62.0439 86.866C62.0439 86.866 62.2628 86.8755 62.6785 86.8903",
    stroke: "#FEB9D6",
    strokeWidth: 0.423123,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9238 86.9351C72.8517 87.2461 111.059 88.3917 123.012 85.7429",
    stroke: "#FEB9D6",
    strokeWidth: 0.423123,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "1.25 1.25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M123.613 85.599C123.825 85.5447 124.029 85.489 124.225 85.4319",
    stroke: "#FEB9D6",
    strokeWidth: 0.423123,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0212 30.7854C67.0212 30.7854 62.241 60.1215 94.5073 59.0468C126.774 57.9721 124.683 40.3458 125.878 27.4988C121.317 29.2918 67.0212 30.7854 67.0212 30.7854Z",
    fill: "#FB61A2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M121.538 89.6895C121.538 89.6895 107.977 103.257 104.391 108.037C100.805 112.817 97.6699 119.538 93.4873 119.089C89.3047 118.641 81.7541 116.588 78.5976 116.367C75.4411 116.146 68.247 118.983 64.8112 119.111C61.3754 119.239 54.6562 111.949 54.6562 111.949L79.9844 113.137L98.9868 100.732L105.9 98.629L121.538 89.6895Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4961 111.719C54.4961 111.719 63.3584 99.8145 77.4992 94.4377C91.6399 89.0609 133.918 84.3716 135.98 83.7285C138.042 83.0853 102.073 94.4493 102.073 94.4493L72.61 107.597L54.4961 111.719Z",
    fill: "#FEB9D6"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5542 96.271C88.5586 103.696 91.7173 110.321 90.6087 111.068C89.5001 111.814 84.5443 106.402 79.5398 98.9769C74.5353 91.5521 72.4863 84.1792 72.4863 84.1792C72.4863 84.1792 78.5497 88.8452 83.5542 96.271Z",
    fill: "#E83E71"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7224 89.0413C77.5223 89.3743 77.2661 89.6702 76.9652 89.9159C76.4026 90.3922 75.6974 90.6676 74.9609 90.6986C74.503 89.6843 74.1148 88.7472 73.7891 87.9191C74.1095 87.8905 74.4195 87.7908 74.6965 87.6272C74.7304 87.6071 74.7653 87.586 74.8023 87.5627C75.0902 87.3683 75.3207 87.1002 75.4697 86.7864C76.173 87.4633 76.687 87.9731 77.0445 88.3358L77.1502 88.4479L77.1904 88.4881L77.2962 88.6002C77.3692 88.6753 77.4432 88.7515 77.5162 88.8287L77.6272 88.945L77.7224 89.0413Z",
    fill: "#FFF5F9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5536 96.2706C88.558 103.695 91.7167 110.32 90.6081 111.067C90.4409 111.18 90.1849 111.152 89.857 110.998C89.7512 108.957 86.8349 103.23 82.5846 96.9233C80.9002 94.4419 79.0202 92.0991 76.9624 89.9174C76.15 89.0532 75.382 88.2873 74.6934 87.6283C74.7272 87.6082 74.7621 87.5871 74.7991 87.5638C75.0871 87.3694 75.3176 87.1012 75.4666 86.7874C75.9521 87.2475 76.48 87.7637 77.0375 88.3318V88.337L77.1432 88.4492L77.1834 88.4894L77.2892 88.6015C77.3622 88.6766 77.4363 88.7528 77.5092 88.83L77.6203 88.9463C77.651 88.9781 77.6817 89.0087 77.7113 89.0426C79.8547 91.2867 81.8088 93.7043 83.5536 96.2706Z",
    fill: "#7E1778"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6475 98.2297C77.4191 93.4325 75.6567 90.4125 74.6465 87.6326C74.508 87.7257 73.832 87.9182 73.832 87.9182C73.832 87.9182 75.1077 92.4012 79.4945 99.0072C83.9182 105.671 89.4537 111.846 90.5623 111.099C90.7633 110.964 90.8236 110.635 90.7591 110.147C88.8127 109.044 84.7465 104.312 80.6475 98.2297Z",
    fill: "#FEB9D6"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4922 102.437C82.9684 108.194 86.711 113.523 85.8489 114.34C84.9867 115.158 79.8521 111.154 74.3801 105.398C68.9081 99.6411 66.0234 93.4932 66.0234 93.4932C66.0234 93.4932 72.0159 96.6803 77.4922 102.437Z",
    fill: "#FB61A2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3182 96.974C71.1941 97.2953 71.0152 97.5927 70.7894 97.8529C70.3676 98.3522 69.7916 98.6968 69.1522 98.8322C68.6011 98.0126 68.122 97.2511 67.7148 96.5742C67.9913 96.5019 68.2482 96.369 68.4668 96.185C68.4933 96.1617 68.5208 96.1384 68.5472 96.1131C68.7706 95.9005 68.9331 95.6321 69.0179 95.3357C69.7318 95.8233 70.2574 96.1934 70.6244 96.4578L70.7365 96.5393L70.7778 96.57L70.8888 96.6514L71.1152 96.8185L71.2294 96.9031L71.3182 96.974Z",
    fill: "#FFF5F9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4909 102.437C82.9671 108.193 86.7097 113.523 85.8475 114.34C85.7185 114.464 85.4911 114.477 85.1801 114.391C84.7876 112.62 81.3889 108.044 76.7377 103.151C74.8969 101.229 72.9054 99.4576 70.7823 97.8533C69.9434 97.2186 69.1585 96.659 68.4551 96.1851C68.4815 96.1618 68.509 96.1386 68.5355 96.1132C68.7589 95.9006 68.9214 95.6322 69.0062 95.3357C69.4981 95.6657 70.0365 96.0391 70.6077 96.4549H70.613L70.7251 96.5363L70.7664 96.567L70.8775 96.6484L71.1038 96.8156L71.2181 96.9002L71.3122 96.9711C73.5183 98.6203 75.5849 100.448 77.4909 102.437Z",
    fill: "#FB61A2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2372 104.581C71.7009 100.862 69.7154 98.4783 68.4206 96.1956C68.3149 96.3013 67.75 96.5658 67.75 96.5658C67.75 96.5658 69.5292 100.299 74.3433 105.431C79.1986 110.607 84.9552 115.192 85.8142 114.374C85.9697 114.227 85.9739 113.931 85.8459 113.512C83.9768 112.835 79.7233 109.3 75.2372 104.581Z",
    fill: "#FB61A2"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M135.979 83.7287C135.979 83.7287 74.9785 94.3533 54.6602 111.945C62.7217 121.027 72.8777 113.013 82.1377 114.704C91.3978 116.396 93.5473 117.332 97.5511 110.441C102.41 102.085 129.356 83.4611 135.979 83.7287Z",
    fill: "#10C9BE"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 83,
    width: 82,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.979 83.7287C135.979 83.7287 74.9785 94.3533 54.6602 111.945C62.7217 121.027 72.8777 113.013 82.1377 114.704C91.3978 116.396 93.5473 117.332 97.5511 110.441C102.41 102.085 129.356 83.4611 135.979 83.7287Z",
    fill: "#FFE39B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0202 85.7422C65.0097 85.7422 65.8118 84.9401 65.8118 83.9506C65.8118 82.9611 65.0097 82.1589 64.0202 82.1589C63.0307 82.1589 62.2285 82.9611 62.2285 83.9506C62.2285 84.9401 63.0307 85.7422 64.0202 85.7422Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7545 87.5552C69.744 87.5552 70.5462 86.7531 70.5462 85.7636C70.5462 84.7741 69.744 83.9719 68.7545 83.9719C67.765 83.9719 66.9629 84.7741 66.9629 85.7636C66.9629 86.7531 67.765 87.5552 68.7545 87.5552Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8541 90.1861C74.8436 90.1861 75.6458 89.3839 75.6458 88.3944C75.6458 87.4049 74.8436 86.6028 73.8541 86.6028C72.8646 86.6028 72.0625 87.4049 72.0625 88.3944C72.0625 89.3839 72.8646 90.1861 73.8541 90.1861Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5885 91.9991C79.578 91.9991 80.3802 91.1969 80.3802 90.2074C80.3802 89.2179 79.578 88.4158 78.5885 88.4158C77.599 88.4158 76.7969 89.2179 76.7969 90.2074C76.7969 91.1969 77.599 91.9991 78.5885 91.9991Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2995 84.5459C74.2889 84.5459 75.0911 83.7438 75.0911 82.7543C75.0911 81.7648 74.2889 80.9626 73.2995 80.9626C72.31 80.9626 71.5078 81.7648 71.5078 82.7543C71.5078 83.7438 72.31 84.5459 73.2995 84.5459Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0358 86.3589C79.0253 86.3589 79.8274 85.5568 79.8274 84.5673C79.8274 83.5778 79.0253 82.7756 78.0358 82.7756C77.0463 82.7756 76.2441 83.5778 76.2441 84.5673C76.2441 85.5568 77.0463 86.3589 78.0358 86.3589Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6881 94.6309C84.6776 94.6309 85.4798 93.8287 85.4798 92.8392C85.4798 91.8498 84.6776 91.0476 83.6881 91.0476C82.6986 91.0476 81.8965 91.8498 81.8965 92.8392C81.8965 93.8287 82.6986 94.6309 83.6881 94.6309Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4205 96.4441C89.41 96.4441 90.2122 95.642 90.2122 94.6525C90.2122 93.663 89.41 92.8608 88.4205 92.8608C87.4311 92.8608 86.6289 93.663 86.6289 94.6525C86.6289 95.642 87.4311 96.4441 88.4205 96.4441Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1334 88.9895C84.1229 88.9895 84.9251 88.1874 84.9251 87.1979C84.9251 86.2084 84.1229 85.4062 83.1334 85.4062C82.1439 85.4062 81.3418 86.2084 81.3418 87.1979C81.3418 88.1874 82.1439 88.9895 83.1334 88.9895Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8678 90.8028C88.8573 90.8028 89.6595 90.0006 89.6595 89.0111C89.6595 88.0216 88.8573 87.2195 87.8678 87.2195C86.8783 87.2195 86.0762 88.0216 86.0762 89.0111C86.0762 90.0006 86.8783 90.8028 87.8678 90.8028Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6784 85.98C88.6679 85.98 89.47 85.1779 89.47 84.1884C89.47 83.1989 88.6679 82.3967 87.6784 82.3967C86.6889 82.3967 85.8867 83.1989 85.8867 84.1884C85.8867 85.1779 86.6889 85.98 87.6784 85.98Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4147 87.7932C93.4042 87.7932 94.2063 86.9911 94.2063 86.0016C94.2063 85.0121 93.4042 84.21 92.4147 84.21C91.4252 84.21 90.623 85.0121 90.623 86.0016C90.623 86.9911 91.4252 87.7932 92.4147 87.7932Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5221 99.0747C94.5116 99.0747 95.3138 98.2726 95.3138 97.2831C95.3138 96.2936 94.5116 95.4915 93.5221 95.4915C92.5326 95.4915 91.7305 96.2936 91.7305 97.2831C91.7305 98.2726 92.5326 99.0747 93.5221 99.0747Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2565 100.888C99.246 100.888 100.048 100.086 100.048 99.0961C100.048 98.1066 99.246 97.3044 98.2565 97.3044C97.267 97.3044 96.4648 98.1066 96.4648 99.0961C96.4648 100.086 97.267 100.888 98.2565 100.888Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9674 93.4346C93.9569 93.4346 94.7591 92.6325 94.7591 91.643C94.7591 90.6535 93.9569 89.8513 92.9674 89.8513C91.9779 89.8513 91.1758 90.6535 91.1758 91.643C91.1758 92.6325 91.9779 93.4346 92.9674 93.4346Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7018 95.2476C98.6913 95.2476 99.4934 94.4454 99.4934 93.4559C99.4934 92.4665 98.6913 91.6643 97.7018 91.6643C96.7123 91.6643 95.9102 92.4665 95.9102 93.4559C95.9102 94.4454 96.7123 95.2476 97.7018 95.2476Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3307 90.0591C99.3202 90.0591 100.122 89.257 100.122 88.2675C100.122 87.278 99.3202 86.4758 98.3307 86.4758C97.3412 86.4758 96.5391 87.278 96.5391 88.2675C96.5391 89.257 97.3412 90.0591 98.3307 90.0591Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.067 91.8723C104.057 91.8723 104.859 91.0702 104.859 90.0807C104.859 89.0912 104.057 88.2891 103.067 88.2891C102.078 88.2891 101.275 89.0912 101.275 90.0807C101.275 91.0702 102.078 91.8723 103.067 91.8723Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.778 84.4187C98.7675 84.4187 99.5696 83.6166 99.5696 82.6271C99.5696 81.6376 98.7675 80.8354 97.778 80.8354C96.7885 80.8354 95.9863 81.6376 95.9863 82.6271C95.9863 83.6166 96.7885 84.4187 97.778 84.4187Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.512 86.232C103.502 86.232 104.304 85.4298 104.304 84.4403C104.304 83.4508 103.502 82.6487 102.512 82.6487C101.523 82.6487 100.721 83.4508 100.721 84.4403C100.721 85.4298 101.523 86.232 102.512 86.232Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.358 103.52C104.348 103.52 105.15 102.718 105.15 101.728C105.15 100.739 104.348 99.9365 103.358 99.9365C102.369 99.9365 101.566 100.739 101.566 101.728C101.566 102.718 102.369 103.52 103.358 103.52Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.089 105.333C109.078 105.333 109.88 104.531 109.88 103.541C109.88 102.552 109.078 101.75 108.089 101.75C107.099 101.75 106.297 102.552 106.297 103.541C106.297 104.531 107.099 105.333 108.089 105.333Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.803 97.8784C103.793 97.8784 104.595 97.0763 104.595 96.0868C104.595 95.0973 103.793 94.2952 102.803 94.2952C101.814 94.2952 101.012 95.0973 101.012 96.0868C101.012 97.0763 101.814 97.8784 102.803 97.8784Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.536 99.6917C108.525 99.6917 109.327 98.8895 109.327 97.9C109.327 96.9105 108.525 96.1084 107.536 96.1084C106.546 96.1084 105.744 96.9105 105.744 97.9C105.744 98.8895 106.546 99.6917 107.536 99.6917Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.346 94.8689C108.336 94.8689 109.138 94.0668 109.138 93.0773C109.138 92.0878 108.336 91.2856 107.346 91.2856C106.357 91.2856 105.555 92.0878 105.555 93.0773C105.555 94.0668 106.357 94.8689 107.346 94.8689Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.081 96.6822C113.07 96.6822 113.872 95.88 113.872 94.8905C113.872 93.901 113.07 93.0989 112.081 93.0989C111.091 93.0989 110.289 93.901 110.289 94.8905C110.289 95.88 111.091 96.6822 112.081 96.6822Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.794 89.2276C107.783 89.2276 108.585 88.4254 108.585 87.4359C108.585 86.4464 107.783 85.6443 106.794 85.6443C105.804 85.6443 105.002 86.4464 105.002 87.4359C105.002 88.4254 105.804 89.2276 106.794 89.2276Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.526 91.0406C112.516 91.0406 113.318 90.2384 113.318 89.2489C113.318 88.2594 112.516 87.4573 111.526 87.4573C110.537 87.4573 109.734 88.2594 109.734 89.2489C109.734 90.2384 110.537 91.0406 111.526 91.0406Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.188 107.963C114.178 107.963 114.98 107.161 114.98 106.172C114.98 105.182 114.178 104.38 113.188 104.38C112.199 104.38 111.396 105.182 111.396 106.172C111.396 107.161 112.199 107.963 113.188 107.963Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.924 109.777C118.914 109.777 119.716 108.974 119.716 107.985C119.716 106.995 118.914 106.193 117.924 106.193C116.935 106.193 116.133 106.995 116.133 107.985C116.133 108.974 116.935 109.777 117.924 109.777Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.635 102.323C113.625 102.323 114.427 101.521 114.427 100.532C114.427 99.5421 113.625 98.74 112.635 98.74C111.646 98.74 110.844 99.5421 110.844 100.532C110.844 101.521 111.646 102.323 112.635 102.323Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37 104.137C118.359 104.137 119.161 103.334 119.161 102.345C119.161 101.355 118.359 100.553 117.37 100.553C116.38 100.553 115.578 101.355 115.578 102.345C115.578 103.334 116.38 104.137 117.37 104.137Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.999 98.9478C118.988 98.9478 119.79 98.1456 119.79 97.1561C119.79 96.1666 118.988 95.3645 117.999 95.3645C117.009 95.3645 116.207 96.1666 116.207 97.1561C116.207 98.1456 117.009 98.9478 117.999 98.9478Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.735 100.761C123.724 100.761 124.527 99.9589 124.527 98.9694C124.527 97.9799 123.724 97.1777 122.735 97.1777C121.746 97.1777 120.943 97.9799 120.943 98.9694C120.943 99.9589 121.746 100.761 122.735 100.761Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.448 93.3076C118.437 93.3076 119.24 92.5055 119.24 91.516C119.24 90.5265 118.437 89.7244 117.448 89.7244C116.458 89.7244 115.656 90.5265 115.656 91.516C115.656 92.5055 116.458 93.3076 117.448 93.3076Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.178 95.1206C123.168 95.1206 123.97 94.3185 123.97 93.329C123.97 92.3395 123.168 91.5374 122.178 91.5374C121.189 91.5374 120.387 92.3395 120.387 93.329C120.387 94.3185 121.189 95.1206 122.178 95.1206Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.073 88.0313C117.062 88.0313 117.865 87.2291 117.865 86.2396C117.865 85.2501 117.062 84.448 116.073 84.448C115.083 84.448 114.281 85.2501 114.281 86.2396C114.281 87.2291 115.083 88.0313 116.073 88.0313Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.973 85.4007C111.963 85.4007 112.765 84.5985 112.765 83.609C112.765 82.6195 111.963 81.8174 110.973 81.8174C109.984 81.8174 109.182 82.6195 109.182 83.609C109.182 84.5985 109.984 85.4007 110.973 85.4007Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.807 89.8443C121.797 89.8443 122.599 89.0421 122.599 88.0526C122.599 87.0631 121.797 86.261 120.807 86.261C119.818 86.261 119.016 87.0631 119.016 88.0526C119.016 89.0421 119.818 89.8443 120.807 89.8443Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.253 84.2032C121.242 84.2032 122.044 83.401 122.044 82.4115C122.044 81.422 121.242 80.6199 120.253 80.6199C119.263 80.6199 118.461 81.422 118.461 82.4115C118.461 83.401 119.263 84.2032 120.253 84.2032Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9635 113.96C58.953 113.96 59.7552 113.158 59.7552 112.169C59.7552 111.179 58.953 110.377 57.9635 110.377C56.974 110.377 56.1719 111.179 56.1719 112.169C56.1719 113.158 56.974 113.96 57.9635 113.96Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6979 115.772C63.6874 115.772 64.4895 114.97 64.4895 113.981C64.4895 112.991 63.6874 112.189 62.6979 112.189C61.7084 112.189 60.9062 112.991 60.9062 113.981C60.9062 114.97 61.7084 115.772 62.6979 115.772Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4108 108.319C58.4003 108.319 59.2024 107.517 59.2024 106.527C59.2024 105.538 58.4003 104.736 57.4108 104.736C56.4213 104.736 55.6191 105.538 55.6191 106.527C55.6191 107.517 56.4213 108.319 57.4108 108.319Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1452 110.132C63.1347 110.132 63.9368 109.33 63.9368 108.34C63.9368 107.351 63.1347 106.549 62.1452 106.549C61.1557 106.549 60.3535 107.351 60.3535 108.34C60.3535 109.33 61.1557 110.132 62.1452 110.132Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9557 105.309C62.9452 105.309 63.7473 104.507 63.7473 103.518C63.7473 102.528 62.9452 101.726 61.9557 101.726C60.9662 101.726 60.1641 102.528 60.1641 103.518C60.1641 104.507 60.9662 105.309 61.9557 105.309Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.692 107.123C67.6815 107.123 68.4837 106.32 68.4837 105.331C68.4837 104.341 67.6815 103.539 66.692 103.539C65.7025 103.539 64.9004 104.341 64.9004 105.331C64.9004 106.32 65.7025 107.123 66.692 107.123Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3991 99.6682C62.3886 99.6682 63.1907 98.8661 63.1907 97.8766C63.1907 96.8871 62.3886 96.085 61.3991 96.085C60.4096 96.085 59.6074 96.8871 59.6074 97.8766C59.6074 98.8661 60.4096 99.6682 61.3991 99.6682Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1354 101.481C67.1249 101.481 67.927 100.679 67.927 99.6896C67.927 98.7001 67.1249 97.8979 66.1354 97.8979C65.1459 97.8979 64.3438 98.7001 64.3438 99.6896C64.3438 100.679 65.1459 101.481 66.1354 101.481Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7995 118.404C68.7889 118.404 69.5911 117.602 69.5911 116.612C69.5911 115.623 68.7889 114.821 67.7995 114.821C66.81 114.821 66.0078 115.623 66.0078 116.612C66.0078 117.602 66.81 118.404 67.7995 118.404Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2448 112.763C68.2343 112.763 69.0364 111.961 69.0364 110.971C69.0364 109.982 68.2343 109.18 67.2448 109.18C66.2553 109.18 65.4531 109.982 65.4531 110.971C65.4531 111.961 66.2553 112.763 67.2448 112.763Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9791 114.576C72.9686 114.576 73.7708 113.774 73.7708 112.784C73.7708 111.795 72.9686 110.993 71.9791 110.993C70.9896 110.993 70.1875 111.795 70.1875 112.784C70.1875 113.774 70.9896 114.576 71.9791 114.576Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 109.388C73.5975 109.388 74.3997 108.586 74.3997 107.597C74.3997 106.607 73.5975 105.805 72.608 105.805C71.6186 105.805 70.8164 106.607 70.8164 107.597C70.8164 108.586 71.6186 109.388 72.608 109.388Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3444 111.201C78.3339 111.201 79.136 110.399 79.136 109.41C79.136 108.42 78.3339 107.618 77.3444 107.618C76.3549 107.618 75.5527 108.42 75.5527 109.41C75.5527 110.399 76.3549 111.201 77.3444 111.201Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0534 103.747C73.0429 103.747 73.845 102.945 73.845 101.955C73.845 100.966 73.0429 100.164 72.0534 100.164C71.0639 100.164 70.2617 100.966 70.2617 101.955C70.2617 102.945 71.0639 103.747 72.0534 103.747Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7897 105.56C77.7792 105.56 78.5813 104.758 78.5813 103.769C78.5813 102.779 77.7792 101.977 76.7897 101.977C75.8002 101.977 74.998 102.779 74.998 103.769C74.998 104.758 75.8002 105.56 76.7897 105.56Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6803 98.472C71.6698 98.472 72.472 97.6698 72.472 96.6803C72.472 95.6908 71.6698 94.8887 70.6803 94.8887C69.6908 94.8887 68.8887 95.6908 68.8887 96.6803C68.8887 97.6698 69.6908 98.472 70.6803 98.472Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4166 100.285C76.4061 100.285 77.2083 99.4828 77.2083 98.4933C77.2083 97.5038 76.4061 96.7017 75.4166 96.7017C74.4271 96.7017 73.625 97.5038 73.625 98.4933C73.625 99.4828 74.4271 100.285 75.4166 100.285Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1276 92.8304C71.1171 92.8304 71.9192 92.0282 71.9192 91.0387C71.9192 90.0492 71.1171 89.2471 70.1276 89.2471C69.1381 89.2471 68.3359 90.0492 68.3359 91.0387C68.3359 92.0282 69.1381 92.8304 70.1276 92.8304Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.86 94.6436C75.8495 94.6436 76.6516 93.8414 76.6516 92.8519C76.6516 91.8624 75.8495 91.0603 74.86 91.0603C73.8705 91.0603 73.0684 91.8624 73.0684 92.8519C73.0684 93.8414 73.8705 94.6436 74.86 94.6436Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0788 117.208C78.0682 117.208 78.8704 116.406 78.8704 115.416C78.8704 114.427 78.0682 113.625 77.0788 113.625C76.0893 113.625 75.2871 114.427 75.2871 115.416C75.2871 116.406 76.0893 117.208 77.0788 117.208Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8151 119.021C82.8046 119.021 83.6067 118.219 83.6067 117.229C83.6067 116.24 82.8046 115.438 81.8151 115.438C80.8256 115.438 80.0234 116.24 80.0234 117.229C80.0234 118.219 80.8256 119.021 81.8151 119.021Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6237 114.198C82.6132 114.198 83.4153 113.396 83.4153 112.407C83.4153 111.417 82.6132 110.615 81.6237 110.615C80.6342 110.615 79.832 111.417 79.832 112.407C79.832 113.396 80.6342 114.198 81.6237 114.198Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.358 116.011C87.3475 116.011 88.1497 115.209 88.1497 114.22C88.1497 113.23 87.3475 112.428 86.358 112.428C85.3686 112.428 84.5664 113.23 84.5664 114.22C84.5664 115.209 85.3686 116.011 86.358 116.011Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0709 108.557C82.0604 108.557 82.8626 107.755 82.8626 106.765C82.8626 105.776 82.0604 104.974 81.0709 104.974C80.0814 104.974 79.2793 105.776 79.2793 106.765C79.2793 107.755 80.0814 108.557 81.0709 108.557Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8034 110.37C86.7929 110.37 87.595 109.568 87.595 108.579C87.595 107.589 86.7929 106.787 85.8034 106.787C84.8139 106.787 84.0117 107.589 84.0117 108.579C84.0117 109.568 84.8139 110.37 85.8034 110.37Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.278 118.277C93.2675 118.277 94.0696 117.475 94.0696 116.485C94.0696 115.496 93.2675 114.694 92.278 114.694C91.2885 114.694 90.4863 115.496 90.4863 116.485C90.4863 117.475 91.2885 118.277 92.278 118.277Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7233 112.636C92.7128 112.636 93.5149 111.834 93.5149 110.844C93.5149 109.855 92.7128 109.052 91.7233 109.052C90.7338 109.052 89.9316 109.855 89.9316 110.844C89.9316 111.834 90.7338 112.636 91.7233 112.636Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4557 114.449C97.4452 114.449 98.2473 113.647 98.2473 112.657C98.2473 111.668 97.4452 110.866 96.4557 110.866C95.4662 110.866 94.6641 111.668 94.6641 112.657C94.6641 113.647 95.4662 114.449 96.4557 114.449Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3502 107.361C91.3397 107.361 92.1419 106.558 92.1419 105.569C92.1419 104.579 91.3397 103.777 90.3502 103.777C89.3607 103.777 88.5586 104.579 88.5586 105.569C88.5586 106.558 89.3607 107.361 90.3502 107.361Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0846 109.174C96.0741 109.174 96.8763 108.371 96.8763 107.382C96.8763 106.392 96.0741 105.59 95.0846 105.59C94.0951 105.59 93.293 106.392 93.293 107.382C93.293 108.371 94.0951 109.174 95.0846 109.174Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7975 101.719C90.787 101.719 91.5891 100.917 91.5891 99.9276C91.5891 98.9381 90.787 98.136 89.7975 98.136C88.808 98.136 88.0059 98.9381 88.0059 99.9276C88.0059 100.917 88.808 101.719 89.7975 101.719Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.528 103.533C95.5175 103.533 96.3196 102.73 96.3196 101.741C96.3196 100.751 95.5175 99.9492 94.528 99.9492C93.5385 99.9492 92.7363 100.751 92.7363 101.741C92.7363 102.73 93.5385 103.533 94.528 103.533Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.737 117.446C101.726 117.446 102.529 116.644 102.529 115.654C102.529 114.665 101.726 113.863 100.737 113.863C99.7475 113.863 98.9453 114.665 98.9453 115.654C98.9453 116.644 99.7475 117.446 100.737 117.446Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 119.259C106.461 119.259 107.263 118.457 107.263 117.467C107.263 116.478 106.461 115.676 105.471 115.676C104.482 115.676 103.68 116.478 103.68 117.467C103.68 118.457 104.482 119.259 105.471 119.259Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.018 116.249C111.008 116.249 111.81 115.447 111.81 114.458C111.81 113.468 111.008 112.666 110.018 112.666C109.029 112.666 108.227 113.468 108.227 114.458C108.227 115.447 109.029 116.249 110.018 116.249Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.546 111.643C101.535 111.643 102.337 110.84 102.337 109.851C102.337 108.861 101.535 108.059 100.546 108.059C99.5561 108.059 98.7539 108.861 98.7539 109.851C98.7539 110.84 99.5561 111.643 100.546 111.643Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.921 113.617C105.91 113.617 106.712 112.815 106.712 111.826C106.712 110.836 105.91 110.034 104.921 110.034C103.931 110.034 103.129 110.836 103.129 111.826C103.129 112.815 103.931 113.617 104.921 113.617Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.753 118.062C115.742 118.062 116.544 117.26 116.544 116.271C116.544 115.281 115.742 114.479 114.753 114.479C113.763 114.479 112.961 115.281 112.961 116.271C112.961 117.26 113.763 118.062 114.753 118.062Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.464 110.608C110.453 110.608 111.255 109.806 111.255 108.816C111.255 107.827 110.453 107.025 109.464 107.025C108.474 107.025 107.672 107.827 107.672 108.816C107.672 109.806 108.474 110.608 109.464 110.608Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6276 106.164C100.617 106.164 101.419 105.362 101.419 104.372C101.419 103.383 100.617 102.581 99.6276 102.581C98.6381 102.581 97.8359 103.383 97.8359 104.372C97.8359 105.362 98.6381 106.164 99.6276 106.164Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.729 108.795C105.719 108.795 106.521 107.993 106.521 107.003C106.521 106.014 105.719 105.212 104.729 105.212C103.74 105.212 102.938 106.014 102.938 107.003C102.938 107.993 103.74 108.795 104.729 108.795Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.198 112.421C115.187 112.421 115.99 111.619 115.99 110.63C115.99 109.64 115.187 108.838 114.198 108.838C113.208 108.838 112.406 109.64 112.406 110.63C112.406 111.619 113.208 112.421 114.198 112.421Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5163 102.916C81.5057 102.916 82.3079 102.113 82.3079 101.124C82.3079 100.134 81.5057 99.3323 80.5163 99.3323C79.5268 99.3323 78.7246 100.134 78.7246 101.124C78.7246 102.113 79.5268 102.916 80.5163 102.916Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4323 105.182C87.4218 105.182 88.2239 104.38 88.2239 103.391C88.2239 102.401 87.4218 101.599 86.4323 101.599C85.4428 101.599 84.6406 102.401 84.6406 103.391C84.6406 104.38 85.4428 105.182 86.4323 105.182Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0612 99.9063C86.0507 99.9063 86.8528 99.1041 86.8528 98.1146C86.8528 97.1251 86.0507 96.323 85.0612 96.323C84.0717 96.323 83.2695 97.1251 83.2695 98.1146C83.2695 99.1041 84.0717 99.9063 85.0612 99.9063Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7975 101.719C90.787 101.719 91.5891 100.917 91.5891 99.9276C91.5891 98.9381 90.787 98.136 89.7975 98.136C88.808 98.136 88.0059 98.9381 88.0059 99.9276C88.0059 100.917 88.808 101.719 89.7975 101.719Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9616 97.2754C80.9511 97.2754 81.7532 96.4733 81.7532 95.4838C81.7532 94.4943 80.9511 93.6921 79.9616 93.6921C78.9721 93.6921 78.1699 94.4943 78.1699 95.4838C78.1699 96.4733 78.9721 97.2754 79.9616 97.2754Z",
    fill: "#DCF6FE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M124.223 88.6357C123.424 88.9288 122.53 89.2778 121.539 89.6935C109.822 94.5468 93.36 110.118 90.0861 111.579C86.8122 113.039 78.9791 108.683 67.2449 110.976C58.0599 112.774 55.4429 112.213 54.7395 111.886L54.6602 111.953C62.7217 121.035 72.8777 113.021 82.1378 114.713C91.3978 116.404 93.5473 117.34 97.5511 110.45C100.795 104.857 113.906 94.6896 124.223 88.6357Z",
    fill: "#10C9BE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M137.82 131.303C137.82 131.303 140.331 119.893 137.82 114.714C136.059 119.538 137.82 131.303 137.82 131.303Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M136.338 132.664C135.015 130.142 136.808 124.512 132.027 119.112C132.622 125.661 136.338 132.664 136.338 132.664Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M135.984 84.6902C134.834 87.2977 129.314 89.3985 128.064 96.5006C132.816 91.952 135.984 84.6902 135.984 84.6902Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7207 130.598C58.4925 128.369 64.3655 127.732 67.3728 121.184C61.6236 124.372 56.7207 130.598 56.7207 130.598Z",
    fill: "#FEB9D6"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1754 123.523C39.0263 117.282 43.4797 104.389 48.2884 93.6444C48.4323 93.3229 48.498 92.9719 48.4803 92.6201C48.4627 92.2683 48.362 91.9257 48.1867 91.6202C48.0114 91.3147 47.7663 91.055 47.4714 90.8622C47.1766 90.6695 46.8404 90.5492 46.4902 90.5112C43.4225 90.1738 41.7205 89.1043 40.7717 88.0328C39.7805 86.9157 37.9875 87.0585 37.2259 88.3427L37.2058 88.3766C32.6572 96.0986 26.1686 108.744 24.4381 120.587C24.3671 121.068 24.4545 121.558 24.6871 121.985C24.9198 122.412 25.285 122.751 25.7275 122.952C29.2118 124.545 32.9493 125.512 36.7689 125.808C37.0807 125.832 37.3941 125.79 37.6888 125.686C37.9834 125.581 38.2528 125.415 38.4796 125.2C38.7064 124.985 38.8855 124.724 39.0054 124.435C39.1252 124.147 39.1832 123.836 39.1754 123.523Z",
    fill: "#FEB9D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 120.586C24.4375 120.586 25.9785 115.404 28.5168 114.709L24.4375 120.586Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7697 125.809C36.7697 125.809 32.7014 116.59 34.049 110.446C35.6886 114.907 36.7697 125.809 36.7697 125.809Z",
    fill: "#FEB9D6"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4914 90.5112C43.4238 90.1738 41.7218 89.1043 40.7729 88.0328C39.7818 86.9157 37.9888 87.0585 37.2272 88.3427L37.2071 88.3766C37.2071 88.3766 36.7839 97.6937 48.2876 93.6444C48.4314 93.3231 48.4972 92.9722 48.4796 92.6206C48.4621 92.2689 48.3616 91.9264 48.1865 91.6209C48.0114 91.3155 47.7666 91.0557 47.472 90.8629C47.1774 90.67 46.8414 90.5495 46.4914 90.5112Z",
    fill: "#10C9BE"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 87,
    width: 12,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4914 90.5112C43.4238 90.1738 41.7218 89.1043 40.7729 88.0328C39.7818 86.9157 37.9888 87.0585 37.2272 88.3427L37.2071 88.3766C37.2071 88.3766 36.7839 97.6937 48.2876 93.6444C48.4314 93.3231 48.4972 92.9722 48.4796 92.6206C48.4621 92.2689 48.3616 91.9264 48.1865 91.6209C48.0114 91.3155 47.7666 91.0557 47.472 90.8629C47.1774 90.67 46.8414 90.5495 46.4914 90.5112Z",
    fill: "#FFE39B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8659 98.1219C38.8554 98.1219 39.6575 97.3197 39.6575 96.3302C39.6575 95.3407 38.8554 94.5386 37.8659 94.5386C36.8764 94.5386 36.0742 95.3407 36.0742 96.3302C36.0742 97.3197 36.8764 98.1219 37.8659 98.1219Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0729 89.159C37.0624 89.159 37.8645 88.3568 37.8645 87.3673C37.8645 86.3778 37.0624 85.5757 36.0729 85.5757C35.0834 85.5757 34.2812 86.3778 34.2812 87.3673C34.2812 88.3568 35.0834 89.159 36.0729 89.159Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6569 92.7437C40.6464 92.7437 41.4485 91.9415 41.4485 90.952C41.4485 89.9625 40.6464 89.1604 39.6569 89.1604C38.6674 89.1604 37.8652 89.9625 37.8652 90.952C37.8652 91.9415 38.6674 92.7437 39.6569 92.7437Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2428 97.2249C44.2323 97.2249 45.0345 96.4227 45.0345 95.4332C45.0345 94.4437 44.2323 93.6416 43.2428 93.6416C42.2533 93.6416 41.4512 94.4437 41.4512 95.4332C41.4512 96.4227 42.2533 97.2249 43.2428 97.2249Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0338 91.8479C46.0233 91.8479 46.8255 91.0458 46.8255 90.0563C46.8255 89.0668 46.0233 88.2646 45.0338 88.2646C44.0443 88.2646 43.2422 89.0668 43.2422 90.0563C43.2422 91.0458 44.0443 91.8479 45.0338 91.8479Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4518 87.3677C42.4413 87.3677 43.2434 86.5656 43.2434 85.5761C43.2434 84.5866 42.4413 83.7844 41.4518 83.7844C40.4623 83.7844 39.6602 84.5866 39.6602 85.5761C39.6602 86.5656 40.4623 87.3677 41.4518 87.3677Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6198 95.4329C49.6093 95.4329 50.4114 94.6307 50.4114 93.6413C50.4114 92.6518 49.6093 91.8496 48.6198 91.8496C47.6303 91.8496 46.8281 92.6518 46.8281 93.6413C46.8281 94.6307 47.6303 95.4329 48.6198 95.4329Z",
    fill: "#DCF6FE"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2056 88.3767C37.2056 88.3767 36.7465 97.7997 48.2861 93.6446",
    stroke: "#FEB9D6",
    strokeWidth: 0.528903,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M137.44 46.8101C135.642 48.3968 132.43 50.8234 128.895 51.5607C128.607 51.6219 128.338 51.7518 128.112 51.9393C127.885 52.1268 127.707 52.3663 127.593 52.6374C127.478 52.9085 127.431 53.2033 127.455 53.4965C127.48 53.7898 127.574 54.0728 127.731 54.3216C131.819 60.7742 134.375 69.9158 132.025 72.7877C130.216 74.9996 138.961 73.9777 145.284 71.9531C146.07 64.5738 143.274 54.9541 139.479 46.5499C139.153 46.3838 138.783 46.3199 138.42 46.3663C138.056 46.4127 137.715 46.5673 137.44 46.8101Z",
    fill: "#FB61A2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M140.632 70.1399C137.944 72.7294 132.025 72.7844 132.025 72.7844L131.913 72.942C130.692 74.8757 139.191 73.7883 145.284 71.9498C143.77 71.3352 142.175 72.0535 140.632 70.1399Z",
    fill: "#FEB9D6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9467 94.1735C47.9467 94.1735 44.8372 95.5801 42.8457 97.2184C44.9462 98.3311 48.19 93.9038 47.9467 94.1735Z",
    fill: "#FEB9D6"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M137.438 46.8099C135.639 48.3966 132.428 50.8233 128.893 51.5605C128.56 51.6301 128.253 51.7918 128.008 52.0273C127.763 52.2628 127.589 52.5626 127.506 52.8923C127.506 52.8923 138.824 60.4028 139.478 46.5455C139.151 46.3798 138.781 46.3164 138.417 46.3636C138.053 46.4107 137.712 46.5663 137.438 46.8099Z",
    fill: "#10C9BE"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 46,
    width: 13,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.438 46.8099C135.639 48.3966 132.428 50.8233 128.893 51.5605C128.56 51.6301 128.253 51.7918 128.008 52.0273C127.763 52.2628 127.589 52.5626 127.506 52.8923C127.506 52.8923 138.824 60.4028 139.478 46.5455C139.151 46.3798 138.781 46.3164 138.417 46.3636C138.053 46.4107 137.712 46.5663 137.438 46.8099Z",
    fill: "#FFE39B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.733 55.251C129.723 55.251 130.525 54.4489 130.525 53.4594C130.525 52.4699 129.723 51.6677 128.733 51.6677C127.744 51.6677 126.941 52.4699 126.941 53.4594C126.941 54.4489 127.744 55.251 128.733 55.251Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.694 57.9407C138.683 57.9407 139.486 57.1386 139.486 56.1491C139.486 55.1596 138.683 54.3574 137.694 54.3574C136.704 54.3574 135.902 55.1596 135.902 56.1491C135.902 57.1386 136.704 57.9407 137.694 57.9407Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.526 48.979C131.516 48.979 132.318 48.1769 132.318 47.1874C132.318 46.1979 131.516 45.3958 130.526 45.3958C129.537 45.3958 128.734 46.1979 128.734 47.1874C128.734 48.1769 129.537 48.979 130.526 48.979Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 48.979C137.092 48.979 137.894 48.1769 137.894 47.1874C137.894 46.1979 137.092 45.3958 136.102 45.3958C135.113 45.3958 134.311 46.1979 134.311 47.1874C134.311 48.1769 135.113 48.979 136.102 48.979Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.313 53.46C135.303 53.46 136.105 52.6578 136.105 51.6684C136.105 50.6789 135.303 49.8767 134.313 49.8767C133.324 49.8767 132.521 50.6789 132.521 51.6684C132.521 52.6578 133.324 53.46 134.313 53.46Z",
    fill: "#DCF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.885 53.46C140.875 53.46 141.677 52.6578 141.677 51.6684C141.677 50.6789 140.875 49.8767 139.885 49.8767C138.896 49.8767 138.094 50.6789 138.094 51.6684C138.094 52.6578 138.896 53.46 139.885 53.46Z",
    fill: "#DCF6FE"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M127.459 52.8427C127.459 52.8427 138.695 60.5647 139.431 46.4958",
    stroke: "#FEB9D6",
    strokeWidth: 0.528903,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0449 133.957C25.4491 135.312 25.9962 136.621 26.6771 137.861C27.374 139.137 28.5294 140.101 29.9098 140.557C99.8308 163.418 153.962 145.964 165.273 140.459C165.962 140.124 166.577 139.653 167.08 139.075C167.676 138.391 168.236 137.675 168.756 136.931C136.232 147.851 90.9156 153.218 25.0449 133.957Z",
    fill: "#FEB9D6"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0413 68.5471C86.0413 68.5471 81.6905 70.2735 81.8397 72.0538C81.9888 73.834 87.0441 75.133 88.1019 74.0329C89.1597 72.9328 86.0413 68.5471 86.0413 68.5471Z",
    fill: "#FB61A2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M103.69 67.0525C103.69 67.0525 100.352 70.3317 101.181 71.9184C102.011 73.5051 107.168 72.7308 107.718 71.3102C108.269 69.8895 103.69 67.0525 103.69 67.0525Z",
    fill: "#FB61A2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 27,
    width: 60,
    height: 33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0212 30.7854C67.0212 30.7854 62.241 60.1215 94.5073 59.0468C126.774 57.9721 124.683 40.3458 125.878 27.4988C121.317 29.2918 67.0212 30.7854 67.0212 30.7854Z",
    fill: "#004F68"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.486 37.3218C120.868 37.3218 121.989 36.1796 121.989 34.7708C121.989 33.3619 120.868 32.2197 119.486 32.2197C118.103 32.2197 116.982 33.3619 116.982 34.7708C116.982 36.1796 118.103 37.3218 119.486 37.3218Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.623 31.83C120.623 31.83 121.925 29.1573 123.432 28.0225",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.398 32.7527L125.543 30.9336",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.041 35.0842L127.272 34.7341",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 37.0845L123.971 39.0231",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.018 37.9734C120.36 39.3631 120.701 40.7532 121.041 42.1437",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.932 37.8982C117.57 39.0066 117.208 40.1143 116.846 41.2213",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.819 34.7763L111.939 34.6853",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.577 32.5548L113.281 29.6675",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.283 31.7242L117.701 28.2424",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.916 36.7493L113.703 37.9751",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8643 54.7902C82.6695 54.7902 84.1329 53.3268 84.1329 51.5216C84.1329 49.7163 82.6695 48.2529 80.8643 48.2529C79.0591 48.2529 77.5957 49.7163 77.5957 51.5216C77.5957 53.3268 79.0591 54.7902 80.8643 54.7902Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3496 47.7549C82.3496 47.7549 84.0492 44.3314 86.0154 42.8718",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6641 48.9359L88.7688 46.6091",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5039 51.9226L91.0248 51.4741",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2031 54.4846L86.7171 56.968",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5605 55.6216C82.0062 57.4026 82.4518 59.1834 82.8974 60.9637",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8373 55.5244C78.3635 56.9424 77.8904 58.361 77.418 59.7804",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0728 51.5279L71.0078 51.4126",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0645 48.6871L72.7578 44.9854",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2936 47.6187L78.5332 43.1597",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2029 54.0549L73.3145 55.6255",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2774 32.9265C93.0927 32.9263 92.9087 32.9509 92.7305 32.9994C92.7305 32.967 92.7305 32.9317 92.7305 32.8937C92.7173 32.366 92.4992 31.8642 92.1226 31.4945C91.7459 31.1247 91.2401 30.9161 90.7123 30.9126C90.1845 30.9092 89.6761 31.1113 89.2946 31.4761C88.9132 31.8409 88.6886 32.3398 88.6685 32.8672C88.1405 32.8672 87.6342 33.077 87.2608 33.4503C86.8875 33.8236 86.6777 34.33 86.6777 34.858C86.6777 35.386 86.8875 35.8924 87.2608 36.2657C87.6342 36.6391 88.1405 36.8488 88.6685 36.8488V36.8774C88.6685 37.416 88.8825 37.9326 89.2634 38.3135C89.6443 38.6944 90.1609 38.9083 90.6995 38.9083C91.2382 38.9083 91.7548 38.6944 92.1356 38.3135C92.5165 37.9326 92.7305 37.416 92.7305 36.8774C92.7305 36.8626 92.7305 36.8477 92.7305 36.8319C92.908 36.8805 93.0912 36.9051 93.2753 36.9049C93.5406 36.911 93.8046 36.864 94.0515 36.7667C94.2985 36.6693 94.5235 36.5236 94.7133 36.3381C94.9031 36.1526 95.054 35.931 95.157 35.6864C95.26 35.4417 95.313 35.179 95.313 34.9135C95.313 34.6481 95.26 34.3853 95.157 34.1407C95.054 33.8961 94.9031 33.6745 94.7133 33.489C94.5235 33.3034 94.2985 33.1577 94.0515 33.0604C93.8046 32.9631 93.5406 32.9161 93.2753 32.9222L93.2774 32.9265ZM90.7302 34.8887C90.9053 34.8866 91.0794 34.8624 91.2485 34.8168C91.2485 34.8495 91.2485 34.8834 91.2485 34.9225C91.2485 34.9373 91.2485 34.9522 91.2485 34.967C91.0798 34.9214 90.906 34.8972 90.7313 34.895L90.7302 34.8887Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.161 50.7495C124.798 50.7499 124.436 50.7964 124.085 50.8881C124.085 50.8246 124.09 50.7611 124.09 50.6966C124.09 48.6212 122.298 46.9382 120.087 46.9382C117.894 46.9382 116.114 48.5926 116.084 50.6406C113.899 50.6691 112.137 52.3405 112.137 54.3989C112.137 56.4574 113.899 58.1288 116.084 58.1563C116.084 58.1743 116.084 58.1922 116.084 58.2113C116.084 60.2867 117.876 61.9697 120.088 61.9697C122.3 61.9697 124.091 60.2867 124.091 58.2113C124.091 58.1827 124.091 58.1542 124.091 58.1256C124.441 58.2178 124.802 58.2643 125.165 58.2642C127.375 58.2642 129.167 56.5812 129.167 54.5047C129.167 52.4283 127.372 50.7495 125.161 50.7495ZM120.142 54.4518C120.487 54.447 120.829 54.4008 121.163 54.3143C121.163 54.3778 121.163 54.4413 121.163 54.5058C121.163 54.5343 121.163 54.5618 121.163 54.5904C120.83 54.5037 120.488 54.4579 120.144 54.454L120.142 54.4518Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.148 44.8964C105.902 44.8962 105.658 44.929 105.421 44.9937C105.421 44.9493 105.421 44.9038 105.421 44.8594C105.413 44.151 105.127 43.4742 104.624 42.9745C104.122 42.4748 103.444 42.1922 102.736 42.1873C102.027 42.1825 101.345 42.4558 100.836 42.9486C100.328 43.4414 100.032 44.1142 100.014 44.8223C99.6619 44.8153 99.3115 44.8786 98.9838 45.0087C98.6561 45.1387 98.3576 45.3328 98.1058 45.5796C97.854 45.8264 97.654 46.1209 97.5174 46.446C97.3809 46.7711 97.3105 47.1201 97.3105 47.4727C97.3105 47.8252 97.3809 48.1743 97.5174 48.4993C97.654 48.8244 97.854 49.1189 98.1058 49.3657C98.3576 49.6125 98.6561 49.8066 98.9838 49.9367C99.3115 50.0667 99.6619 50.13 100.014 50.123C100.014 50.1357 100.014 50.1484 100.014 50.1611C100.014 50.8782 100.299 51.5659 100.806 52.0729C101.313 52.58 102.001 52.8648 102.718 52.8648C103.435 52.8648 104.123 52.58 104.63 52.0729C105.137 51.5659 105.422 50.8782 105.422 50.1611C105.422 50.141 105.422 50.1219 105.422 50.1018C105.658 50.1661 105.902 50.1989 106.146 50.1992C106.499 50.2062 106.85 50.1428 107.177 50.0128C107.505 49.8827 107.804 49.6885 108.056 49.4416C108.308 49.1947 108.508 48.9 108.644 48.5748C108.781 48.2496 108.851 47.9005 108.851 47.5478C108.851 47.1951 108.781 46.8459 108.644 46.5207C108.508 46.1955 108.308 45.9008 108.056 45.6539C107.804 45.407 107.505 45.2129 107.177 45.0828C106.85 44.9527 106.499 44.8893 106.146 44.8964H106.148ZM102.763 47.5092C102.993 47.507 103.221 47.4765 103.444 47.4182C103.444 47.4626 103.444 47.507 103.444 47.5525C103.444 47.5726 103.444 47.5927 103.444 47.6128C103.22 47.5515 102.989 47.5192 102.756 47.5166L102.763 47.5092Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6916 32.35C71.446 32.3497 71.2016 32.3825 70.9648 32.4473C70.9648 32.4029 70.9648 32.3574 70.9648 32.3119C70.9504 31.6074 70.6616 30.9364 70.1599 30.4416C69.6582 29.9468 68.9832 29.6673 68.2786 29.6627C67.574 29.658 66.8953 29.9284 66.3871 30.4165C65.8789 30.9046 65.5812 31.5717 65.5573 32.276C65.2048 32.2689 64.8545 32.3323 64.5267 32.4623C64.199 32.5923 63.9005 32.7864 63.6487 33.0332C63.397 33.28 63.1969 33.5746 63.0604 33.8996C62.9238 34.2247 62.8535 34.5737 62.8535 34.9263C62.8535 35.2789 62.9238 35.6279 63.0604 35.953C63.1969 36.278 63.397 36.5726 63.6487 36.8194C63.9005 37.0662 64.199 37.2603 64.5267 37.3903C64.8545 37.5203 65.2048 37.5837 65.5573 37.5766V37.6147C65.5573 38.3318 65.8422 39.0195 66.3492 39.5266C66.8563 40.0336 67.544 40.3185 68.2611 40.3185C68.9782 40.3185 69.6659 40.0336 70.1729 39.5266C70.68 39.0195 70.9648 38.3318 70.9648 37.6147C70.9648 37.5946 70.9648 37.5745 70.9648 37.5544C71.2013 37.6192 71.4453 37.6519 71.6905 37.6517C72.3935 37.6517 73.0678 37.3724 73.5649 36.8753C74.0621 36.3782 74.3414 35.7039 74.3414 35.0009C74.3414 34.2978 74.0621 33.6236 73.5649 33.1264C73.0678 32.6293 72.3935 32.35 71.6905 32.35H71.6916ZM68.3013 34.9628C68.5344 34.9598 68.7661 34.9271 68.991 34.8655C68.991 34.911 68.991 34.9554 68.991 35.0009C68.991 35.021 68.991 35.0411 68.991 35.0612C68.7668 34.9999 68.5358 34.9675 68.3034 34.9649L68.3013 34.9628Z",
    stroke: "#FB61A2",
    strokeWidth: 0.952026,
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAich4);
export default __webpack_public_path__ + "static/media/aich4.cca3d2324a61b64d38369a490bc785ac.svg";
export { ForwardRef as ReactComponent };